module.exports = __webpack_public_path__ + "img/fecha-de-compra.175b0649.svg";